import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Project Jarvis"
              description="My personal chat assistant built using python. This is a personal chatbot which uses the speak recognition to recoganize the speak and reply accordingly."
              ghLink="https://github.com/venkataramanTB/Chatbot"
            
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Dynamic Navigation system"
              description="This project is based on the navigation system where the from point and the destination point is in dynamic (moving) condition.The distance between the two locations is identified and displayed. This project is done using Python."
              ghLink="https://github.com/venkataramanTB/Dynamic_Navigation_system"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Student Skillset System"
              description="This is a project based on the skillsets of the students. This skillsets can be analysed by the placement cell of the College for better picking of students based on their skills and to place in a better company."
              ghLink="https://github.com/venkataramanTB/Skillset-System"
                        
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
